/* tslint:disable */
/* eslint-disable */
/**
 * Gallaudet
 * A set of APIs to allow seamless integration of the NUSA Roblox game
with Google Classrooms.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';
import type { AssetContentType } from './AssetContentType';
import {
    AssetContentTypeFromJSON,
    AssetContentTypeFromJSONTyped,
    AssetContentTypeToJSON,
} from './AssetContentType';
import type { AssetStatus } from './AssetStatus';
import {
    AssetStatusFromJSON,
    AssetStatusFromJSONTyped,
    AssetStatusToJSON,
} from './AssetStatus';

/**
 * Metadata returned to clients for a successfully created asset.
 * @export
 * @interface AssetRecord
 */
export interface AssetRecord {
    /**
     * CivicTech-generated identifier for a managed asset.
     * @type {string}
     * @memberof AssetRecord
     */
    assetId: string;
    /**
     * A unique identifier for the Roblox experience/universe.
     * @type {string}
     * @memberof AssetRecord
     */
    experienceId: string;
    /**
     * Original client-side file name.
     * @type {string}
     * @memberof AssetRecord
     */
    fileName: string;
    /**
     * 
     * @type {AssetContentType}
     * @memberof AssetRecord
     */
    contentType: AssetContentType;
    /**
     * File size in bytes.
     * @type {number}
     * @memberof AssetRecord
     */
    sizeBytes: number;
    /**
     * Object key in the service-managed S3 assets bucket.
     * @type {string}
     * @memberof AssetRecord
     */
    objectKey: string;
    /**
     * 
     * @type {AssetStatus}
     * @memberof AssetRecord
     */
    status: AssetStatus;
    /**
     * 
     * @type {number}
     * @memberof AssetRecord
     */
    createdAt: number;
    /**
     * 
     * @type {number}
     * @memberof AssetRecord
     */
    updatedAt: number;
}


/**
 * Check if a given object implements the AssetRecord interface.
 */
export function instanceOfAssetRecord(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "assetId" in value;
    isInstance = isInstance && "experienceId" in value;
    isInstance = isInstance && "fileName" in value;
    isInstance = isInstance && "contentType" in value;
    isInstance = isInstance && "sizeBytes" in value;
    isInstance = isInstance && "objectKey" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "updatedAt" in value;
    return isInstance;
}

export function AssetRecordFromJSON(json: any): AssetRecord {
    return AssetRecordFromJSONTyped(json, false);
}

export function AssetRecordFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetRecord {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'assetId': json['assetId'],
        'experienceId': json['experienceId'],
        'fileName': json['fileName'],
        'contentType': AssetContentTypeFromJSON(json['contentType']),
        'sizeBytes': json['sizeBytes'],
        'objectKey': json['objectKey'],
        'status': AssetStatusFromJSON(json['status']),
        'createdAt': json['createdAt'],
        'updatedAt': json['updatedAt'],
    };
}

export function AssetRecordToJSON(value?: AssetRecord | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'assetId': value.assetId,
        'experienceId': value.experienceId,
        'fileName': value.fileName,
        'contentType': AssetContentTypeToJSON(value.contentType),
        'sizeBytes': value.sizeBytes,
        'objectKey': value.objectKey,
        'status': AssetStatusToJSON(value.status),
        'createdAt': value.createdAt,
        'updatedAt': value.updatedAt,
    };
}

